import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import * as z from "zod";

import AdminRoutes from "Routes/Components/Admin";

import { HTTPErrorCallback } from "Helpers/Error";
import { cpfCnpjMask } from "Helpers/Format";
import { clearMask } from "Helpers/Util";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import Section from "Components/Admin/Section";

import * as S from "./styles";

const CreateSponsor = () => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();
  const navigate = useNavigate();

  const [cnpj, setCnpj] = useState("");

  const formSchema = z.object({
    name: z.string().min(3, "Nome deve ter ao menos 3 caracteres"),
    email: z.string().email("E-mail inválido").optional().or(z.literal("")),
    phone: z.string().optional().or(z.literal("")),
    website: z.string().optional().or(z.literal("")),
    description: z.string().optional().or(z.literal("")),
  });

  const methods = useForm({
    resolver: zodResolver(formSchema),
  });
  const { register } = methods;

  const submit = (data) => {
    if (!cnpj || clearMask(cnpj).length !== 14) {
      showNotification("danger", "Atenção!", "Informe um CNPJ válido.");
      return;
    }

    setLoading(true);

    data.cnpj = clearMask(cnpj);
    if (data.phone) data.phone = clearMask(data.phone);

    api
      .post("/sponsors/create", data)
      .then(() => {
        setLoading(false);
        showNotification(
          "success",
          "Sucesso!",
          "Empresa patrocinadora criada com sucesso!",
        );
        navigate(AdminRoutes.ListSponsors.path);
      })
      .catch((error) => {
        setLoading(false);
        return HTTPErrorCallback(error);
      });
  };

  return (
    <Section>
      <S.Wrapper>
        <FormWrapper submit={submit} {...methods}>
          <Input
            {...register("name")}
            type="text"
            label="Nome da Empresa:"
            placeholder="Razão Social"
            required
          />
          <Input
            name="cnpj"
            type="text"
            label="CNPJ:"
            placeholder="00.000.000/0000-00"
            value={cnpj}
            onChange={(e) => setCnpj(cpfCnpjMask(e.target.value))}
            required
          />
          <Input
            {...register("email")}
            type="email"
            label="E-mail Corporativo:"
            placeholder="contato@empresa.com"
          />
          <Input
            {...register("phone")}
            type="text"
            label="Telefone:"
            placeholder="+55 (00) 00000-0000"
            mask="+99 (99) 99999-9999"
          />
          <Input
            {...register("website")}
            type="text"
            label="Website:"
            placeholder="https://empresa.com.br"
          />
          <Input
            {...register("description")}
            type="text"
            label="Descrição:"
            placeholder="Breve descrição da empresa"
          />

          <Button
            type="submit"
            text={loading ? "Salvando..." : "Criar Empresa"}
            disabled={loading}
          />
        </FormWrapper>
      </S.Wrapper>
    </Section>
  );
};

export default CreateSponsor;
